module.exports = __webpack_public_path__ + "img/mob_View_Background.934ef271.png";